<template>
  <!-- width="1920" height="1080" 可写可不写额 -->
  <v-scale-screen
    fullScreen
    width="1920"
    height="1080"
    :boxStyle="{ background: '#fff' }"
  >
    <div class="full-main">
      <div class="full-header">
        <div class="f-title">
          宿舍监控平台
        </div>
        <div class="full-time">
          <HeaderTime />
        </div>
        <div class="full-sushe">
          <a-select v-model="dormitorySetId">
            <a-select-option
              :value="item.id"
              v-for="(item, index) in dormitorylist"
              :key="index"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="full-body">
        <!-- 左侧 -->
        <div class="full-left">
          <PubBox className="full-left-userlist" title="通行人员动态">
            <div class="full-left-userlist-body">
              <LeftUser v-for="item in 20" :rowData="item" :key="item" />
            </div>
          </PubBox>
        </div>
        <!-- 中间 -->
        <div class="full-middle">
          <div class="full-m-top">
            <PubBox className="full-weather">
              <div class="full-weather-body">
                <Weather />
              </div>
            </PubBox>
            <PubBox className="full-m-num">
              <MiddleNum />
            </PubBox>
          </div>
          <div class="full-m-tongji">
            <PubBox className="full-m-echart" title="人员在寝状态统计">
              <MiddleEchart />
            </PubBox>
            <PubBox className="full-m-table" title="在寝统计">
              <MiddleTable />
            </PubBox>
          </div>
          <PubBox className="full-m-tubiao" title="通行人员每小时汇总">
            <MiddleTubiao />
          </PubBox>
        </div>
        <!-- 右侧 -->
        <div class="full-right">
          <PubBox className="full-right-item1" title="在寝超过12小时人员信息">
            <div class="full-right-item1-body">
              <RightUser v-for="item in 16" :rowData="item" :key="item" />
            </div>
          </PubBox>
          <PubBox className="full-right-item2" title="学生在寝状态详情">
            <div class="full-right-item2-body">
              <RightStudentIn v-for="item in 16" :rowData="item" :key="item" />
            </div>
          </PubBox>
        </div>
      </div>
    </div>
  </v-scale-screen>
</template>

<script>
import { FullScreen } from "@/api";
import PubBox from "./component/PubBox.vue";
import LeftUser from "./component/LeftUser.vue";
import Weather from "./component/Weather.vue";
import HeaderTime from "./component/HeaderTime.vue";
import MiddleNum from "./component/MiddleNum.vue";
import RightStudentIn from "./component/RightStudentIn.vue";
import RightUser from "./component/RightUser.vue";
import MiddleTable from "./component/MiddleTable.vue";
import MiddleEchart from "./component/MiddleEchart.vue";
import MiddleTubiao from "./component/MiddleTubiao.vue";

export default {
  components: {
    PubBox,
    LeftUser,
    Weather,
    HeaderTime,
    MiddleNum,
    RightStudentIn,
    RightUser,
    MiddleTable,
    MiddleEchart,
    MiddleTubiao,
  },
  data() {
    return {
      schoolId: this.$route.query.schoolId,
      dormitorySetId: "",
      dormitorylist: [],
    };
  },
  created() {},
  mounted() {
    this.getDormitory();
    this.getList();
    this.get12List();
  },
  methods: {
    // 左侧数据
    getDormitory() {
      this.loading = true;
      FullScreen.schoolDormitoryPage({
        schoolId: this.schoolId,
        paging: {
          page: 1,
          limit: 99,
          sort: [
            {
              property: "createTime",
              direction: "DESC",
            },
          ],
        },
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.dormitorylist = res.data;
          this.dormitorySetId = res.data[0].id;
        }
        this.loading = false;
      });
    },
    // 左侧数据
    getList() {
      this.loading = true;
      FullScreen.findLastDormitorySignRecord({
        schoolId: this.schoolId,
        dormitorySetId: "2",
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },
    // 查询在宿舍楼待超过12个小时的人员
    get12List() {
      this.loading = true;
      FullScreen.findInDormitory({
        schoolId: "402881e68a7ed93e018a7ef8909c0000",
        dormitorySetId: "2",
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },

    // 翻页回调
    pagesChange(data) {
      this.form.paging.page = data.current;
      this.form.paging.limit = data.pageSize;
      this.getList();
    },
    // 搜索回调
    searchBack(data) {
      data.paging = {
        page: 1,
        limit: this.form.paging.limit,
      };
      this.form = { ...this.form, ...data };
      this.getList();
    },
    // 删除
    deleteCustomer(id) {
      this.pubMsg.confirm("是否确定删除此数据？").then(() => {
        this.loading = true;
        FullScreen.teacherBasicDelete({ ids: id }).then(res => {
          if (res.code == this.config.pubCode) {
            this.pubMsg.tipMessage("删除成功！", "success");
            this.getList();
          }
          this.loading = false;
        });
      });
    },
    // 上传结束
    uploadOk(data) {
      this.importLoading = true;
      FullScreen.teacherBasicImportFile({
        schoolId: this.form.schoolId,
        sysFile: data,
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage("导入成功！", "success");
          this.getList();
        }
        this.importLoading = false;
      });
    },

    add(type, data) {
      this.$refs.addModalModal.open(type, data);
    },
    moduleOk(data) {
      if (data) {
        this.getList();
      }
    },
  },
};
</script>
<style lang="less">
body {
  overflow: hidden !important;
}

@import "./style.less";
</style>
